import { ControlledPlainTextEditor } from '@calendly/rich-text-editor'

import { Label } from './styles'

export const PlainTextField = ({ label, id, ...props }) => (
  <>
    <Label htmlFor={id}>{label}</Label>
    <ControlledPlainTextEditor
      {...props}
      id={id}
    />
  </>
)
